import {
  TRIP_QUOTE_START,
  TRIP_QUOTE_SUCCESS,
  TRIP_QUOTE_FAIL,
  TRIP_QUOTE_FINISH,
  PLAN_TRIP_SELECTED,
  TRIP_DESTINATIONS_SUCCESS,
  SET_PASSENGERS,
  SET_TITULAR_DATA,
  SET_TRIP_DETAILS,
  SET_TRIP_COUNT_PASSENGERS,
  SET_TRIP_FORM,
  SET_FECHA_IDA,
  SET_FECHA_VUELTA,
  SET_USER_LEAD,
  CLEAR_PASSENGERS_DATA,
  CLEAR_TITULAR_DATA,
  SET_TRIP_EMBEDDED,
  SET_URL_EMBEDDED,
  SET_MESSAGE_EMBEDDED,
  SET_VALID_INITIAL_LEAD,
  TRIP_PLANS_SET,
} from "../types/trip";

const initialState = {
  loading: false,
  success: false,
  quote: null,
  originalPlans: null,
  planSelected: null,
  destinations: null,
  titularData: null,
  tripDetails: null,
  tripCountPassengers: {
    counter: 1,
    counterChild: 0,
  },
  tripForm: null,
  tripPassengers: null,
  fechaIda: "",
  fechaVuelta: "",
  userLead: {
    active: false,
    documentNumber: "",
    documentType: "",
    mobile: "",
  },
  isEmbedded: false,
  urlEmbedded: null,
  messageEmbedded: "",
  initialLead: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TRIP_QUOTE_START:
      return {
        ...state,
        loading: true,
      };
    case TRIP_QUOTE_SUCCESS:
      return {
        ...state,
        loading: false,
        quote: action.data,
        success: true,
      };
    case TRIP_PLANS_SET:
      return {
        ...state,
        originalPlans: action.data,
      };
    case TRIP_QUOTE_FAIL:
      return {
        ...state,
        loading: false,
        data: null,
      };
    case TRIP_QUOTE_FINISH:
      return {
        ...state,
      };
    case PLAN_TRIP_SELECTED:
      return {
        ...state,
        planSelected: action.data,
      };
    case TRIP_DESTINATIONS_SUCCESS:
      return {
        ...state,
        destinations: action.data,
      };
    case SET_PASSENGERS:
      return {
        ...state,
        tripPassengers: action.data,
      };
    case SET_TITULAR_DATA:
      return {
        ...state,
        titularData: action.data,
      };
    case SET_TRIP_DETAILS:
      return {
        ...state,
        tripDetails: action.data,
      };
    case SET_TRIP_COUNT_PASSENGERS:
      return {
        ...state,
        tripCountPassengers: action.data,
      };
    case SET_TRIP_FORM:
      return {
        ...state,
        tripForm: action.data,
      };
    case SET_FECHA_IDA:
      return {
        ...state,
        fechaIda: action.data,
      };
    case SET_FECHA_VUELTA:
      return {
        ...state,
        fechaVuelta: action.data,
      };
    case SET_USER_LEAD:
      return {
        ...state,
        userLead: action.data,
      };
    case CLEAR_PASSENGERS_DATA:
      return {
        ...state,
        tripPassengers: null,
      };
    case CLEAR_TITULAR_DATA:
      return {
        ...state,
        titularData: null,
      };
    case SET_TRIP_EMBEDDED:
      return {
        ...state,
        isEmbedded: action.data,
      };
    case SET_URL_EMBEDDED:
      return {
        ...state,
        urlEmbedded: action.data,
      };
    case SET_MESSAGE_EMBEDDED:
      return {
        ...state,
        messageEmbedded: action.data,
      };
    case SET_VALID_INITIAL_LEAD:
      return {
        ...state,
        initialLead: true,
      };
    default:
      return state;
  }
};
